import { RouteRecordRaw } from 'vue-router';
import LoginPage from '@/views/LoginPage.vue';
import Customer from '@/views/userportal/CustomerPortal.vue';

const customerroutes: Array<RouteRecordRaw> = [
    {
      path: "/customer/login",
      name: "login",
      component: LoginPage,
    },
    {
      path: "/customer",
      name: "customerportal",
      component: Customer,
    },
    // {
    //   path: "customer/about",
    //   name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./"),
    // },
  ];

  export default customerroutes;